import React from 'react';
import {
  FileStatus,
  FileStatusType,
} from '@server/application/files/types/file.types';

interface FileStatusTooltipProps {
  status: FileStatus;
}

export const FileStatusTooltip: React.FC<FileStatusTooltipProps> = ({
  status,
}) => {
  const steps: Array<{ key: keyof FileStatus; label: string }> = [
    { key: 'upload', label: 'Upload' },
    { key: 'vectorization', label: 'Encoding' },
    { key: 'extraction', label: 'Media Extraction' },
  ];

  return (
    <div style={{ padding: '8px', background: '#fff', borderRadius: '4px' }}>
      {steps.map(({ key, label }) => {
        const step = status[key];
        const isCompleted = step.status === FileStatusType.COMPLETED;
        const isFailed = step.status === FileStatusType.FAILED;

        return (
          <div
            key={key}
            style={{
              marginBottom: 4,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '12px',
            }}
          >
            <span style={{ minWidth: '100px', color: 'rgba(0, 0, 0, 0.85)' }}>
              {label}
            </span>
            <span
              style={{
                color: isFailed
                  ? '#ff4d4f'
                  : isCompleted
                    ? '#52c41a'
                    : '#FF9800',
              }}
            >
              {step.status.toLowerCase()}
            </span>
          </div>
        );
      })}
    </div>
  );
};
